import { createTheme } from '../utils/create-theme';
export var SHAPEABLE_THEME = createTheme('blaze', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#FCB017',
      primaryDarker: '#F7941C',
      primaryLight: '#FEE7B9',
      primaryLighter: '#FFCB03',
      primaryBright: '#FCB017',
      primaryVeryLight: '#FFF1BD',
      link: '#FCB017',
      linkHover: '#000000',
      navigationActive: '#FCB017'
    }
  },
  dark: {
    color: {
      link: '#7DB248',
      linkHover: '#7DB248'
    }
  }
});
export default SHAPEABLE_THEME;